import { gql, useQuery } from "@apollo/client";
import { useApplicationContext } from "components/Application";
import { CenterSpinner } from "components/CenterSpinner";
import { useFiltersContext } from "components/FiltersContext";
import { Footer } from "components/Footer";
import { ListFilters } from "components/ListFilters";
import { ListItem } from "components/ListItem";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import "twin.macro";

const collectionLineQuery = gql`
  query(
    $lineId: ID!
    $seasonId: ID!
    $colorGroupsFilter: [ID!]
    $compositionGroupsFilter: [ID!]
    $kindGroupsFilter: [ID!]
  ) {
    collectionLine(id: $lineId) {
      id
      code
      nameEn
      nameIt
      brand {
        id
        nameEn
        nameIt
      }
      items(
        seasonFilter: $seasonId
        colorGroupsFilter: $colorGroupsFilter
        compositionGroupsFilter: $compositionGroupsFilter
        kindGroupsFilter: $kindGroupsFilter
      ) {
        id
        code
        nameEn
        nameIt
        cover
        available
        kind {
          id
          code
        }
        color {
          id
          code
          nameEn
          nameIt
          patch
        }
        sizeGroup {
          id
          code
          sizes {
            id
            code
            value
          }
        }
        season {
          id
          isStock
        }
        stocks {
          quantity
          size {
            id
            code
          }
        }
        variants {
          id
          available
          color {
            id
            code
            patch
          }
        }
      }
    }
    collectionSeason(id: $seasonId) {
      id
      code
      nameEn
      nameIt
      kindEn
      kindIt
      colorGroups {
        id
        code
        nameEn
        nameIt
        patch
      }
      compositionGroups {
        id
        code
        nameEn
        nameIt
      }
      kindGroups {
        id
        code
        nameEn
        nameIt
      }
    }
  }
`;

export const Show: React.FC<{}> = () => {
  const { session } = useApplicationContext();
  const { filteredColorGroups, filteredCompositionGroups, filteredKindGroups } = useFiltersContext();
  const { currentUser } = session;
  const { priceList } = currentUser;
  const { prices } = priceList;
  const { seasonId, lineId } = useParams();

  const { i18n } = useTranslation();

  const variables = {
    lineId,
    seasonId,
    colorGroupsFilter: filteredColorGroups.map((colorGroup) => colorGroup.id),
    compositionGroupsFilter: filteredCompositionGroups.map((compositionGroup) => compositionGroup.id),
    kindGroupsFilter: filteredKindGroups.map((kindGroup) => kindGroup.id),
  };
  const { loading, data } = useQuery(collectionLineQuery, { variables, fetchPolicy: "cache-and-network" });

  if (loading) return <CenterSpinner size="large" />;

  const { collectionLine: line, collectionSeason: season } = data;
  const { brand, items } = line;
  const { colorGroups, compositionGroups, kindGroups } = season;

  return (
    <div tw="flex space-x-2">
      <div tw="flex flex-col w-full">
        <ListFilters
          brand={brand}
          season={season}
          line={line}
          colorGroups={colorGroups}
          compositionGroups={compositionGroups}
          kindGroups={kindGroups}
        />

        {items.length > 0 && (
          <div tw="grid lg:grid-cols-4 lg:gap-4 lg:mx-4 lg:my-4 grid-cols-3 mx-4 mt-8 gap-4">
            {items.map((item: any) => (
              <ListItem key={item.code} item={item} brand={brand} prices={prices} hideLineIcon />
            ))}
          </div>
        )}
        {items.length === 0 && (
          <div tw="text-lg text-gray-500 text-center mt-24 mb-64">
            {i18n.language === "it" ? "Nessun articolo trovato." : "No articles found."}
          </div>
        )}

        <Footer />
      </div>
    </div>
  );
};
